<template>
    <div class="property-item"
         @mouseover.prevent="animateOnHover(true)"
         @mouseout.prevent="animateOnHover(false)"
    >
        <div class="col-1">
            <wp-image v-if="propertyImage" class="property-image"
                      :image="propertyImage"
                      sizeHD="landscape-hd"
                      :isBackground="true"
                      tag="div"
            />
        </div>
        <div class="col-2">
            <div class="property-body">
                <h4 class="property-title" v-html="propertyTitle"></h4>
                <address class="address" v-html="propertyAddress"></address>
                <div class="property-type" v-html="propertyTypes"></div>
                <div class="wrap-price">
                    <div class="property-amenities" v-html="propertyAmenities"></div>
                    <div class="property-price hidden" v-html="propertyFromPrice"></div>
                </div>
            </div>
            <div class="availability">
                {{propertyAvailability}}
            </div>
        </div>

        <!--Garage-->
        <!--Smoke-Free Certified-->
        <!--Playground-->

        <a v-if="propertyUrl"
           :href="propertyUrl.url"
           :rel="propertyUrl.rel"
           class="overlay"
           :target="propertyUrl.target">
            <div>
                <span v-if="propertyUrl.title" v-html="propertyUrl.title"></span>
                <span v-else>View Property</span>
            </div>
        </a>
    </div>
</template>

<script>

    import WpImage from '../WpImage';
    import PropertyMixin from './mixin.property';
    import {MapEventHub} from './MapEventHub';
    import LinkElement from '../LinkElement'

    export default {
        components: {WpImage, LinkElement},
        mixins: [PropertyMixin],
        data() {
            return {}
        },
        props: {
            property: {
                type: Object,
                default: Object
            },
            enableMapEvents: {
                type: Boolean,
                default: false,
            },
            show_button: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            animateOnHover(val) {

                if (!this.enableMapEvents)
                    return false;

                MapEventHub.hoverType = 'list';

                if(val)
                    MapEventHub.activeProperty = this.property;
                else {
                    if (MapEventHub.activeProperty) {
                        let property = MapEventHub.activeProperty;
                        let activeMarker = MapEventHub.mappedMarkers[property.id];
                        activeMarker.customPin.removeClass('pin-hover');
                    }
                    MapEventHub.activeProperty = null;
                }
            },
        }
    }

</script>
<style lang="scss" type="text/scss" scoped>
    .property-amenities {
        color: #808080!important;
        svg {
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            fill: #808080!important;
        }
    }

    .hidden{
        display: none;
    }

    .property-title {
        margin-bottom: 5px;
        margin-top: 5px;
        font-size: 22px;
        color: #000;
    }

    address.address, .property-type {
        font-style: normal;
        font-size: 12px;
        color: #808080;
        letter-spacing: 0;
        margin-bottom: 8px;
    }

    address.address {
        font-weight: 600;
    }

    .property-image {
        background-position: center center;
        background-size: cover;
        max-width: 100%;
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
        position: absolute;
    }

    .property-price {
        color: $theme-green;
        font-weight: 700;
        font-size: 14px;
    }

    .wrap-price {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .property-item {
        margin-bottom: 25px;
        position: relative;
        overflow: hidden;

        .col-1 {
            position: relative;
        }

        .overlay {
            background-color: rgba($theme-green, .9);
            color: #fff;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
            pointer-events: none;
            transition: all .3s ease-in-out;

            div {
                position: absolute;
                width: calc(100% - 30px);
                height: calc(100% - 30px);
                left: 15px;
                top: 15px;
                border: 1px solid #fff;

                span {
                    font-size: $font-family-size;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    text-align: center;
                    width: 100%;
                    left: 0;
                }
            }
        }

        &:hover {
            .overlay {
                opacity: 1;
                pointer-events: all;
            }
        }
    }

    .availability {
        text-align: center;
        font-size: 13px;
        color: #6EB71D;
        border-bottom: 2px solid;
        padding-bottom: 5px;
    }

</style>
